<template>

    <div class="dd-m-extra--bookmark-box">
        <button v-on:click="toggleBookmark()"
                v-bind:class="{'is-active': mutableActive}"
                class="dd-m-extra--bookmark-btn"
                type="button">
            <i class="dd-m-icon icon-bookmark"></i>
            <i class="dd-m-icon icon-bookmark-filled"></i>
        </button>
    </div>
</template>
<script>
    import AuthService from '../../providers/api/auth-service';
    import ProductService from '../../providers/api/product-service';

    const authService = new AuthService(),
        productService = new ProductService();

    export default {
        name: 'bookmark-btn',
        props: ['product_id', 'isActive', 'preload'],
        data: () => {
            return {
                mutableActive: this.isActive
            }
        },
        mounted() {
            this.mutableActive = this.isActive;

            if (this.preload) {
                this.getProduct();
            }
        },
        methods: {
            getProduct() {
                productService.doGetProductById(this.product_id, authService.isSigned())
                    .then((res) => this.mutableActive = res.data.data.wishlist ? res.data.data : false)
            },
            addToWishlist() {
                productService.addToWishlist(this.product_id)
                    .catch(() => this.mutableActive = !this.mutableActive);
            },
            removeToWishlist() {
                productService.removeToWishlist(this.product_id)
                    .catch(() => this.mutableActive = !this.mutableActive);
            },
            toggleBookmark() {
                this.mutableActive = !this.mutableActive;

                if (!authService.isSigned()) {
                    this.mutableActive = !this.mutableActive;
                    PubSub.publish('openLoginModal');
                } else {
                    if (this.mutableActive) {
                        this.addToWishlist();
                    } else {
                        this.removeToWishlist();
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/products/bookmark-btn.vue